import { Action } from 'redux';

import { OpenManageItemsInCollectionsDialog } from '../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { initialManageItemsTelemetry,ManageItemsTelemetry } from '../space/CollectionsTelemetry';

export interface ManageItemsInCollectionsDialogAction extends Action {
  targetItems: IContentInfo[];
  targetCollectionLuids?: string[];
  manageItemsTelemetry: ManageItemsTelemetry;
}

export function openManageItemsInCollectionsDialogAction(
  targetItems: IContentInfo[],
  targetCollectionLuids?: string[],
  manageItemsTelemetry?: ManageItemsTelemetry
): ManageItemsInCollectionsDialogAction {
  return {
    type: OpenManageItemsInCollectionsDialog,
    targetItems,
    targetCollectionLuids,
    manageItemsTelemetry: manageItemsTelemetry || initialManageItemsTelemetry()
  };
}
